import React, { useEffect, useState } from 'react';
import EndorsementsApi from '../../../api/EndorsementsApi';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import DocumentsTable from '../../DocumentsTable';

interface Props {
	endorsementData: EndorsementData;
	authData: AuthData;
}

const DocumentsView = (props: Props) => {
	const {
		endorsementData,
		authData: { auth },
	} = props;
	const { endorsementUpdateObj } = endorsementData;

	const [documents, setDocuments] = useState(endorsementUpdateObj.documents);

	useEffect(() => {
		let timer: any = 0;
		const fetchEndorsement = async () => {
			try {
				const updatedEndorsement = await EndorsementsApi.getEndorsement(
					auth.authorizationToken,
					endorsementUpdateObj.locator,
				);
				setDocuments(updatedEndorsement.data.documents);
				if (
					updatedEndorsement.data.documents &&
					!updatedEndorsement.data.documents.every((d) => !!d.url)
				) {
					timer = setTimeout(() => {
						fetchEndorsement();
					}, 30000);
				}
			} catch (err) {
				console.error(err);
			}
		};
		if (
			endorsementUpdateObj.documents &&
			!endorsementUpdateObj.documents.every((d) => !!d.url)
		) {
			fetchEndorsement();
		}
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Documents</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<DocumentsTable documents={documents} />
			</StyledSectionContainer>
		</>
	);
};

export default withEndorsementContext<Props>(DocumentsView);
